import React from 'react'

const Delete = props => {
    return (
        <div className="delete-container">
            <div className="delete-container-btn"><button className="okay">Sil</button></div>
            <div className="delete-container-btn"><button className="exit" onClick={props.closeModal}>Vazgeç</button></div>
        </div>
    )
}

export default Delete
